import React from "react";

export const Projects: React.FC = () => {
  return <div>Hello Projects!</div>;
};
